import { useEffect, useState } from 'react';
import { useMapEvent } from 'react-leaflet';

const useZoomLevel = () => {
  const [zoomLevel, setZoomLevel] = useState(1);

  // Обновляем уровень зума при изменении
  useMapEvent('zoom', (event) => {
    setZoomLevel(event.target._zoom); // Получаем уровень зума из события
  });

  return zoomLevel;
};

export default useZoomLevel;